module.exports = __webpack_public_path__ + "static/media/CourseExpiringSoon.ecd01d07.svg";